// Public site URL (used for canonical, OG, sitemap, JSON-LD)
export const SITE_URL = "https://garantiasextraordinarias.com";
export const SITE_NAME = "Garantías Extraordinarias";
export const SITE_AUTHOR = "Edmundo Treviño";
export const SITE_TWITTER = "@edmundotrevino";
export const BOOK_ISBN = "6287831340";

// Self-hosted images (relative paths — served from client/public/images/).
// WebP for on-site display: ~50% lighter than JPG at same quality, supported
// by 97%+ of browsers. Absolute URLs for Open Graph fall back to JPEG since
// some social previewers (Facebook classic, LinkedIn scraper) still have
// spotty WebP handling in shares.
export const LIBRO_PORTADA_URL = "/images/libro-portada.webp";
export const EDMUNDO_PERFIL_URL = "/images/edmundo-perfil.webp";
export const EDMUNDO_FERIA_URL = "/images/edmundo-feria.webp";
export const EDMUNDO_FIRMANDO_URL = "/images/edmundo-firmando.webp";
export const EDMUNDO_CON_LECTOR_URL = "/images/edmundo-con-lector.webp";
export const LIBRO_ATRIL_URL = "/images/libro-atril.webp";

// Default OG/JSON-LD image — absolute URL is required by Open Graph spec.
// Kept as JPEG for maximum previewer compatibility.
export const SITE_DEFAULT_OG_IMAGE = `${SITE_URL}/images/libro-portada.jpeg`;

// External links
export const EDMUNDO_SITE = "https://edmundotrevino.com";

// Amazon listing (worldwide)
export const AMAZON_LIBRO_URL = "https://www.amazon.com/dp/6287831340";

// PayPal "No-Code Payments" for direct purchase (USD)
export const PAYPAL_LIBRO_URL = "https://www.paypal.com/ncp/payment/S9H74GZYTZE7L";
export const PAYPAL_MENTORIA_URL = "https://www.paypal.com/ncp/payment/5AXQDEJJH5BZ2";

// WhatsApp for custom corporate package quotes (international format, no + or spaces)
export const PAQUETE_WHATSAPP_PHONE = "523346766178";

// Industry categories for blog posts and reader ideas
export const INDUSTRIES = [
  "Automotriz",
  "Restaurantes y Hospitalidad",
  "Salud y Clínicas",
  "Educación",
  "Tecnología",
  "E-commerce",
  "Servicios Profesionales",
  "Franquicias",
  "Construcción",
  "Retail / Comercio",
  "Membresías",
  "Consultoría",
  "Otro",
] as const;

export const BLOG_CATEGORIES = [
  "Garantía de Producto",
  "Garantía de Servicio",
  "Garantía de Satisfacción",
  "Garantía de Tiempo",
  "Garantía de Precio",
  "Garantía de Resultado",
  "Garantía Emocional",
  "Estrategia",
  "Caso de Éxito",
  "Otro",
] as const;
